/* Pompeii — Quick Add to Cart
   Custom element for adding products to cart via AJAX */

if (!customElements.get('quick-add-button')) {
  customElements.define('quick-add-button', class QuickAddButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (this.button) {
        this.button.addEventListener('click', this.onButtonClick.bind(this));
      }
    }

    onButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const variantId = this.button.dataset.productId;
      if (!variantId) return;

      const originalText = this.button.textContent.trim();

      // Show loading state
      this.button.classList.add('loading');
      this.button.disabled = true;
      this.button.textContent = '...';

      // Add to cart via Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }]
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(data => {
        // Success feedback
        this.button.textContent = '✓ Añadido';
        this.button.classList.remove('loading');

        setTimeout(() => {
          this.button.textContent = originalText;
          this.button.disabled = false;
        }, 2000);

        // Dispatch custom event so cart drawer / counter can update
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { items: data.items || data }
        }));

        // Refresh cart count in header if element exists
        this.updateCartCount();
      })
      .catch(error => {
        console.error('Quick Add Error:', error);
        this.button.classList.remove('loading');
        this.button.textContent = 'Error';

        setTimeout(() => {
          this.button.textContent = originalText;
          this.button.disabled = false;
        }, 2000);
      });
    }

    updateCartCount() {
      fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      })
      .then(r => r.json())
      .then(cart => {
        const counters = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
        counters.forEach(el => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
        });
      })
      .catch(() => { /* silent fail for cart count */ });
    }
  });
}
